import { keepDeliveryUrlMediaUrl } from '../../../utils/mediaDeliveryUrls'
import { calculateImageDeliveryValues } from '../image/calculateImageDeliveryValues'

export function setImageAttributes(imageNode, nodePos, attributes) {
  const { tr } = window.view.state
  const imageDeliveryValues = calculateImageDeliveryValues(attributes.fileId, attributes.originalDimensions, attributes.crop, attributes.rotate, attributes.colorAdjust, attributes.markup.covers, attributes.markup.markers)
  const { deliveryUrl } = imageDeliveryValues
  const deliveryDimensions = {
    w: imageDeliveryValues.w,
    h: imageDeliveryValues.h,
  }
  tr.setMeta('triggerParseDoc', true)
  tr.setNodeMarkup(nodePos, null, {
    ...attributes,
    deliveryUrl: keepDeliveryUrlMediaUrl(deliveryUrl),
    deliveryDimensions,
    placeholderImage: null,
  })
  window.view.dispatch(tr)
}
